export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/identity.js
// module id = IRat
// module chunks = 0